import('jquery');

(function ($) {
    $.fn.bindWithDelay = function (type, data, fn, timeout) {
        let wait = null;
        const that = this;
        if ($.isFunction(data)) {
            timeout = fn;
            fn = data;
            data = void 0;
        }
        const cb = function (e) {
            clearTimeout(wait);
            const cachedEvent = $.extend({}, e);
            wait = setTimeout((function () {
                fn.apply(that, [cachedEvent]);
            }), timeout);
        };
        return this.bind(type, data, cb);
    };
})(jQuery);
document.addEventListener("turbolinks:load", function () {
    console.log('turbolinks:load from stops');
    const $query = $('#query');
    const $spinner = $('#spinner');
    const $results = $('#results');

    $query.bindWithDelay('keyup', function (event) {
        if (![37, 38, 39, 40].includes(event.keyCode)) {
            $spinner.show();
            const form = $(this).closest('form');
            const url = form.attr('action');
            const formData = form.serialize();
            $.get(url, formData, function (html) {
                $spinner.hide();
                $results.html(html);
            });
        }
    }, 500);

    $query.keyup(function (event) {
        if (event.keyCode === 40) {
            jQuery.tableNavigation({
                cookie_name: null,
                selected_class: 'table-primary'
            });
        }
    });

    $query.keypress(function (event) {
        if (event.which === 13) {
            event.preventDefault();
        }
    });

    const $buttonRevealer = $('#button-revealer');
    $buttonRevealer.click(function () {
        let curReveal = parseInt($(this).attr('data-reveal-start'));
        const maxReveal = parseInt($(this).attr('data-reveal-stop'));
        $(`.timeline > .reveal-${curReveal}`).removeClass(`d-none reveal-${curReveal}`);
        if (curReveal >= maxReveal) {
            $(this).remove();
        } else {
            $(this).attr('data-reveal-start', curReveal + 1);
        }
    });
});
